import React, { useState } from 'react';
import {
  SuggestComboBox,
  SuggestComboBoxProps,
} from '../../../components/molecules/Form/components/ComboBox/AbstractComboBox/SuggestComboBox';
import { TopContentResult } from '../../../components/molecules/Form/components/ComboBox';
import { useHtmlValidId } from '../../../hooks/useHtmlValidId';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import getContentTopResults from '../../../components/molecules/Form/components/ComboBox/Content/getContentTopResult';
import ListItemPage from '../../../components/molecules/Form/components/ComboBox/AbstractComboBox/ListItemPage/ListItemPage';
import { PrivilegedGroupsMultiSelectListItem } from './PrivilegedGroupsMultiSelectListItem';
import { PrivilegedGroupParam } from './PrivilegedGroupsAddForm';
import {
  FormsComboboxMultiSelectList,
  FormsComboboxMultiSelectListModifier,
} from '../../../components/molecules/Form/components/FormsComboboxMultiSelect/partials/FormsComboboxMultiSelectList';

type PrivilegedGroupsSelectComboBoxProps = {
  grantedRolesParam: PrivilegedGroupParam<'grantedRoles'>;
};

export function PrivilegedGroupsSelectComboBox({
  grantedRolesParam,
  ...props
}: PrivilegedGroupsSelectComboBoxProps &
  Omit<SuggestComboBoxProps<TopContentResult>, 'id' | 'onSelection' | 'validationMessage'>) {
  const { t } = useSonTranslation('PrivilegedGroups');
  const [selectedResults, setSelectedResults] = useState<TopContentResult[]>([]);

  const id = useHtmlValidId();
  const headerLabelId = useHtmlValidId();

  const removeResult = (item: TopContentResult) => {
    setSelectedResults(prevState => prevState.filter(result => result.id !== item.id));
  };

  const addResult = (item?: TopContentResult) => {
    if (item && !selectedResults.some(result => result.id === item.id)) {
      setSelectedResults(prevState => [...prevState, item]);
    }
  };

  return (
    <>
      <SuggestComboBox
        {...props}
        name={undefined}
        id={`content-select-combobox-${id}`}
        responseMapper={getContentTopResults}
        onSelection={item => {
          addResult(item as TopContentResult);
        }}
        validationMessage={
          props.required && !selectedResults.length ? t('FormsComboBox:content.validationMessage') : undefined
        }
      >
        {item => <ListItemPage page={item as TopContentResult} />}
      </SuggestComboBox>
      {selectedResults && selectedResults.length > 0 && (
        <>
          <h3 className="invisible" id={headerLabelId}>
            {t('multiSelectLabel')}
          </h3>
          <FormsComboboxMultiSelectList
            labelId={headerLabelId}
            modifier={FormsComboboxMultiSelectListModifier.MARGIN_TOP}
          >
            {selectedResults.map((selectedResult, groupIndex) => (
              <PrivilegedGroupsMultiSelectListItem
                key={selectedResult.id}
                selectedResult={selectedResult}
                removeResult={removeResult}
                grantedRolesParam={grantedRolesParam}
                groupIndex={groupIndex}
              />
            ))}
          </FormsComboboxMultiSelectList>
        </>
      )}
    </>
  );
}
